import React, { useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import Group from 'components/utils/Group'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import ContactContext from 'contexts/contactContext'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled.div`
  padding: ${rem(20)};

  ${mediaQueryUp.largeDesktop} {
    padding: ${rem(20)} 0;
  }
`

function BundleAndSaveCallUs() {
  const currentContact = useContext(ContactContext)
  const supportContact = currentContact.defaultContact

  return (
    <Container>
      <Group gap={0} tabletGap={8} direction="vertical">
        <BodyText variant="large" weight="bold">
          Want to mix and match room types?
        </BodyText>
        <Group direction="vertical" desktopDirection="horizontal" gap="12 0" desktopGap="0 12">
          <BodyText variant="medium" colour="neutral-three">
            Call our customer service team 24 hours, 7 days.
          </BodyText>
          <TextLink
            startIcon={<LinePhoneIcon />}
            size="medium"
            href={`tel:${supportContact.number}`}
          >
            {supportContact.humanReadable}
          </TextLink>
        </Group>
      </Group>
    </Container>
  )
}

export default BundleAndSaveCallUs
